import Header from "../header"
import "./index.css"
import TaskBar from "../taskbar";
import CopyRight from "../copyright";

const CountrieUsa = () => {

    return (
        <>
        <Header />
        <div className="container-head">
          <h1>Why Choose United States as Your Study Destination?</h1>  
          <p>The USA offers a world-leading higher education system, a dynamic and multifaceted culture, and a vast and varied landscape that attracts students globally. </p>
        <p>Key Advantages:  </p>
        <ul>
            <li> Home to 8 of the Top 10 Global Universities   </li>
           <li>Flexible, Dynamic Education System  </li>
           <li> Cutting-edge Research Opportunities  </li>
           <li>Scholarships and Funding Options </li>
           <li>Career-Boosting Optional Practical Training (OPT) Programs </li>
           <li>Multicultural and Inclusive Society  </li>
           <li>Gateway to Permanent Residency Opportunities </li>
        </ul>

        <hr />
        <table>
            <caption>Understanding the UK Higher Education System </caption>
            <thead>
                <tr>
                    <th>Category</th>
                    <th>Details</th>
                </tr>
            </thead>
                <tr>
                    <td>Capital</td>
                    <td>Washington, D.C. </td>
                </tr>
                <tr>
                    <td>Currency</td>
                    <td>US Dollar (USD) </td>
                </tr>
                <tr>
                    <td>Population</td>
                    <td>Over 330 million</td>
                </tr>
                <tr>
                    <td>Number of States</td>
                    <td>50</td>
                </tr>
                <tr>
                    <td>Language</td>
                    <td>English</td>
                </tr>
                <tr>
                    <td>Popular Student Cities</td>
                    <td>New York, Boston, Los Angeles, Chicago, San Francisco </td>
                </tr>
                <tr>
                    <td>Major Intakes</td>
                    <td>Fall (Aug/Sep), Spring (Jan), Summer (May - limited)</td>
                </tr>
                <tr>
                    <td>Climate</td>
                    <td>Diverse: snowy winters in the north, warm south </td>
                </tr>
                <tr>
                    <td>Transport</td>
                    <td>Advanced public transport in major cities</td>
                </tr>
                <tr>
                    <td>Driving Side</td>
                    <td>Right-hand side of the road </td>
                </tr>
        </table>
        

        <hr />

        <h2>The USA Education System: A World of Flexibility </h2>

         <p>The USA offers the most flexible and diverse education system globally, allowing students to design 
their academic journey: </p>
         <p>University Types</p>
         <ul>
            <li>Ivy League and Elite Universities: Harvard, MIT, Stanford, Yale, Princeton </li>
            <li>Public & Private Universities: Research and innovation hubs </li>
            <li>Community Colleges: Affordable pathways for undergraduate study</li>
         </ul>
         <p>Degree Levels </p>
         <table>
            <thead>
                <tr>
                    <th>Level </th>
                    <th>Details</th>
                </tr>
            </thead>
            <tr>
                <td>Undergraduate (UG)</td>
                <td>4 years for Bachelor’s</td>
            </tr>
            <tr>
                <td>Postgraduate (PG)</td>
                <td>1-2 years for Master's; 4-6 years for Ph.D.</td>
            </tr>
            <tr>
                <td>Community College (Associate)</td>
                <td>2-year affordable programs</td>
            </tr>
         </table>
        <hr />
        <h2>Study Programs Overview </h2>
        <table>
            <thead>
                <tr>
                    <th>Feature</th>
                    <th>Undergraduate (UG) </th>
                    <th>Postgraduate (PG)</th>
                </tr>
            </thead>
                <tr>
                    <td>Degree Awarded</td>
                    <td>Bachelor’s </td>
                    <td>Master's or Ph.D. </td>
                </tr>
                <tr>
                    <td>Duration</td>
                    <td>4 years  </td>
                    <td>1-2 years (Master’s), 4-6 years (Ph.D.) </td>
                </tr>
                <tr>
                    <td>Entry Requirements</td>
                    <td>12th Grade + SAT/ACT</td>
                    <td>Bachelor’s Degree + GRE/GMAT</td>
                </tr>
                <tr>
                    <td>Language Test </td>
                    <td>IELTS/TOEFL/Duolingo</td>
                    <td>IELTS/TOEFL/Duolingo</td>
                </tr>
                <tr>
                    <td>Work Opportunities</td>
                    <td>20 hrs/week on-campus</td>
                    <td>20 hrs/week + OPT after graduation</td>
                </tr>
                <tr>
                    <td>Curriculum</td>
                    <td>Broad-based, major-focused</td>
                    <td>$15,000 - $35,000/year</td>
                </tr>
                <tr>
                    <td>Tuition Fees </td>
                    <td> Specialized, research-intensive</td>
                    <td>$20,000 - $50,000/year </td>
                </tr>
                </table>
                <hr/>
                <h2>Intakes and Entry Requirements</h2>
            <table>
            <thead>
                <tr>
                    <th>Intake </th>
                    <th>Timeline </th>
                </tr>
            </thead>
                <tr>
                    <td>Fall</td>
                    <td>August/September(Main Intake)</td>
                </tr>
                <tr>
                    <td>Spring</td>
                    <td>January (Alternate Entry)</td>
                </tr>
                <tr>
                    <td>Summer May</td>
                    <td> (Limited Programs)</td>
                </tr>
                </table>
            <table>
            <thead>
                <tr>
                    <th>Requirement </th>
                    <th>Undergraduate (UG) </th>
                    <th>Postgraduate (PG) </th>
                </tr>
            </thead>
                <tr>
                    <td>Academic Scores  </td>
                    <td>60%+ in 12th </td>
                    <td>55–60%+ in Bachelor's</td>
                </tr>
                <tr>
                    <td>Standardized Tests </td>
                    <td>SAT/ACT (optional) </td>
                    <td>GRE/GMAT (program specific)</td>
                </tr>
                <tr>
                    <td>English Proficiency </td>
                    <td> IELTS/TOEFL/PTE/Duolingo  </td>
                    <td>IELTS/TOEFL/PTE/Duolingo </td>
                </tr>
                <tr>
                    <td>SOP & LORs</td>
                    <td>Required  </td>
                    <rd>Required </rd>
                </tr>
                <tr>
                    <td>Work Experience</td>
                    <td>Not mandatory</td>
                    <td>Preferred for MBA, MS </td>
                </tr>
                </table>
            <hr />
            <h2>Cost of Studying in the USA</h2>
            
               <table>
                   <thead>
                       <tr>
                          <th>Expense</th>
                          <th>Estimated Cost (USD) </th>
                       </tr>
                   </thead>
                   <tr>
                        <td>Public Universities</td>
                        <td>$15,000 – $25,000 per year</td>
                   </tr>
                   <tr>
                        <td>Private Universities</td>
                        <td>$25,000 – $50,000 per year</td>
                   </tr>
                   <tr>
                        <td>Community Colleges </td>
                        <td>Starting from $6,000 per year </td>
                   </tr>
                   <tr>
                        <td>Living Expenses</td>
                        <td>$800 – $1,500 per month </td>
                   </tr>
                   <tr>
                        <td>Health Insurance </td>
                        <td>$500 – $2,000 annually</td>
                   </tr>
                   <tr>
                        <td>Student Visa (F1) Fees</td>
                        <td> $185 (Application) + $350 (SEVIS)</td>
                   </tr>
                   <tr>
                        <td>Books & Supplies</td>
                        <td>$1,000 – $3,000 annually </td>
                   </tr>
                   <tr>
                        <td>Flight Costs </td>
                        <td>$700 – $1,200 (one-way) </td>
                   </tr>
               </table>
           <hr />

           <h2>Scholarships to Study in the USA </h2>
           <p>Unlock incredible scholarship opportunities with Dream Destination: </p>
           <ul>
            <li>Merit-Based Scholarships offered by universities  </li>
            <li>Government Scholarships: Fulbright, AAUW, Inlaks </li>
            <li>Department-Specific Grants: STEM, Business, Law</li>
            <li>Need-Based Financial Aid Packages </li>
           </ul>
           <p>Partial or Full Tuition Waivers available based on academic profile and leadership qualities.</p>
            <hr/>
            <h2>Visa and Essential Documents</h2>
            <p>Many UK universities offer Master’s programs with integrated internships or placement years, offering: </p>
           <table>
               <thead>
                   <tr>
                       <th>Documents</th>
                       <th>For University Admission</th>
                       <th> For Student Visa</th>
                   </tr>
               </thead>
               <tr>
                   <td>Passport </td>
                   <td>&#10004;</td>
                   <td>&#10004;</td>
               </tr>
               <tr>
                   <td>Academic Transcripts </td>
                   <td>&#10004;</td>
                   <td>&#10004;</td>
               </tr>
               <tr>
                   <td>English Proficiency Test (IELTS/TOEFL) </td>
                   <td>&#10004;</td>
                   <td>&#10004;</td>
               </tr>
               <tr>
                   <td>SOP & LORs </td>
                   <td>&#10004;</td>
                   <td></td>
               </tr>
               <tr>
                   <td>Resume/CV</td>
                   <td>&#10004;</td>
                   <td></td>
               </tr>
               <tr>
                   <td>I-20 Form (University Admission Letter)</td>
                   <td></td>
                   <td>&#10004;</td>
               </tr>
               <tr>
                   <td>DS-160 Confirmation Page </td>
                   <td></td>
                   <td>&#10004;</td>
               </tr>
               <tr>
                   <td>SEVIS Fee Receipt </td>
                   <td></td>
                   <td>&#10004;</td>
               </tr>
               <tr>
                   <td>Visa Appointment Confirmation</td>
                   <td></td>
                   <td>&#10004;</td>
               </tr>
               <tr>
                   <td>Financial Proof </td>
                   <td>&#10004;</td>
                   <td>&#10004;</td>
               </tr>
           </table>
           <hr />
           <h2>Work Opportunities: CPT and OPT </h2>
           <p>Curricular Practical Training (CPT) </p>
           <ul>
              <li>Part of your academic program</li>
              <li>Allows paid internships while studying</li>
           </ul>
           <p>Optional Practical Training (OPT) </p>
           <ul>
              <li>12 months of work after graduation</li>
              <li>36 months for STEM graduates</li>
              <li>No job offer required before application</li>
           </ul>
        </div>
        <TaskBar />
        <CopyRight />
        </>
    )

}

export default CountrieUsa